import React from "react";
import "./style.css"; // Import CSS

interface StateProps {
  completionPercentage: number | string; // Replace 'any' with a union type
  customProgressColor?: string; // Make optional with '?'
}

const ProgressBar: React.FC<StateProps> = ({
  completionPercentage = 0,
  customProgressColor,
}) => {
  const percentage = Math.min(
    Math.max(parseInt(completionPercentage.toString(), 10), 0),
    100
  ); // Ensure 0-100 range

  const fillStyle = {
    background: customProgressColor || getColorForPercentage(percentage),
    width: `${percentage}%`,
  };

  return (
    <div className="progress-container" data-testid="progress-container">
      <div className="progress-track">
        <div
          className="progress-fill"
          style={fillStyle}
          data-testid="progress-fill"
        ></div>
      </div>
      <span className="progress-label" data-testid="progress-label">
        {percentage}%
      </span>
    </div>
  );
};

// Gradient color logic
function getColorForPercentage(percentage: number): string {
  if (percentage <= 25) {
    return "#E51F1F";
  } else if (percentage <= 49) {
    return "#F2A134";
  } else if (percentage <= 74) {
    return "#F7E379";
  } else {
    return "#44CE1B";
  }
}

export default ProgressBar;
